import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Summer/Money/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Money',
  field: 'Measurement',
  weeks: [3, 4],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Money/1PoundsAndPence" */ './1PoundsAndPence')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Money/2ConvertPoundsAndPence" */ './2ConvertPoundsAndPence'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () => import(/* webpackChunkName: "Year3/Summer/Money/3AddMoney" */ './3AddMoney')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Money/4SubtractMoney" */ './4SubtractMoney')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () => import(/* webpackChunkName: "Year3/Summer/Money/5FindChange" */ './5FindChange')
    })
  ]
});
export default Block;
